// @flow
'use strict';

import * as React from 'react';

import type { ITomador } from '../types';
import { tipoDocumento } from './abas_informacoes';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';

type TomadorProps = {
  tomador : ITomador,
};

export default function Tomador({ tomador } : TomadorProps) {
  return (
      <div className="tab-pane active">
        <h3>Tomador do Serviço</h3>
        <RowDetalhes data={ tomador } className="no-margin-bottom">
          <ColumnDetalhes field="relacaoCarga" width="50%">Relação com a carga</ColumnDetalhes>
          <ColumnDetalhes field="cnpj" type="documento" width="50%">{ tipoDocumento(tomador) }</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ tomador } className="no-margin-bottom">
          <ColumnDetalhes field="ie" width="50%">Inscrição Estadual</ColumnDetalhes>
          <ColumnDetalhes field="nomeRazaoSocial" width="50%">Nome / Razão Social</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ tomador } className="no-margin-bottom">
          <ColumnDetalhes field="nomeFantasia" width="50%">Nome Fantasia</ColumnDetalhes>
          <ColumnDetalhes field="telefone" width="50%">Telefone</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ tomador } className="no-margin-bottom">
          <ColumnDetalhes field="endereco" width="50%">Endereço</ColumnDetalhes>
          <ColumnDetalhes field="bairro" width="50%">Bairro</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ tomador } className="no-margin-bottom">
          <ColumnDetalhes field="municipio" width="50%">Município</ColumnDetalhes>
          <ColumnDetalhes field="cep" type="cep" width="50%">CEP</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ tomador } className="no-margin-bottom">
          <ColumnDetalhes field="uf" width="50%">UF</ColumnDetalhes>
          <ColumnDetalhes field="pais" width="50%">País</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ tomador }>
          <ColumnDetalhes field="email" width="50%">E-mail</ColumnDetalhes>
        </RowDetalhes>
      </div>
  );
}
